import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import * as Validator from "../../../../../util/validation";
import { AppState } from "../../../../store/app_state";

import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import BtnLinkCancelSmall from "../../../../common/atom/btn/btn_link_cancel_small";
import ErrorText from "../../../../common/atom/text/error_text";
import FormFieldWrapper, {
  PasswordFormFieldWrapper,
  PasswordIconButton,
} from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";
import PageTopInfo from "../../../../common/organism/page_top_info";

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IProps extends InjectedFormProps<FormData, {}> {}

interface IState {
  showPassword: boolean;
}

export class CustomerMypageMainEmailForm extends React.Component<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      showPassword: false,
    };
  }

  public render(): JSX.Element {
    const { anyTouched, invalid, handleSubmit, pristine, submitting } =
      this.props;

    return (
      <React.Fragment>
        <PageTopInfo
          information={`ログインで用いるメールアドレスを変更します`}
          subInformation={`変更前のメールアドレスにメールを送信するので、間違ったメールアドレスを登録した場合は、そちらを使用して以前のメールアドレスに戻してください。`}
        />
        <form name="CustomerMypageMainEmailForm" onSubmit={handleSubmit}>
          <PasswordFormFieldWrapper>
            <Field
              label="パスワード"
              placeholder="入力してください"
              name="currentPassword"
              component={FormGroupInputConnectRf}
              type={this.state.showPassword ? "text" : "password"}
              validate={[Validator.required]}
              require={true}
            />
            <PasswordIconButton
              type="button"
              onClick={() => {
                this.setState((prevState) => ({
                  showPassword: !prevState.showPassword,
                }));
              }}
            >
              {this.state.showPassword ? (
                <i className="fas fa-eye-slash" />
              ) : (
                <i className="fas fa-eye" />
              )}
            </PasswordIconButton>
          </PasswordFormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label="新しいメールアドレス"
              placeholder="入力してください"
              name="email"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[
                Validator.email,
                Validator.emailCount,
                Validator.required,
              ]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label="新しいメールアドレス（確認）"
              placeholder="入力してください"
              name="confirm"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.confirmEmail, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>

          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <SubmitButtonWrapper>
            <CancelButtonWrapper>
              <BtnLinkCancelSmall to="/customer/mypage/customer">
                キャンセル
              </BtnLinkCancelSmall>
            </CancelButtonWrapper>
            <BtnCorporateLarge
              name={"CustomerMypageMainEmailForm-submit"}
              type="submit"
              disabled={pristine || submitting || invalid}
            >
              メールアドレスを再設定する
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "CustomerMypageMainEmailForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(CustomerMypageMainEmailForm));



// WEBPACK FOOTER //
// ./src/presentation/component/customer/mypage/email_update/customer_mypage_main_email_form.tsx